import { render, staticRenderFns } from "./BannersTable.vue?vue&type=template&id=b5ccba30"
import script from "./BannersTable.vue?vue&type=script&lang=js"
export * from "./BannersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports